<div class="flex flex-col py-8 justify-center">
  <div class="container-padding max-w-screen-desktop mx-auto w-full">
    <div class="py-6 px-6 shadow rounded-2xl sm:px-10 my-4 border border-4 border-[var(--black)] bg-[var(--white)]">
      <h2 class="uppercase text-[42px]/[65px] font-normal text-[var(--dark-orange)]">{{ 'payment.title' | translate }}</h2>
      <div class="w-full border-t border-dotted mb-6 mt-2"></div>

      <div class="grid grid-cols-1 tablet:grid-cols-2 gap-12">

        <!-- Resumen de reserva -->
        <div class="col-span-1 space-y-4">
          <div class="flex justify-between items-center">
            <span class="text-[var(--black)]">{{ 'payment.reservationLocator' | translate }}</span>
            <span class="font-semibold text-[var(--black)] text-right">{{ reservation?.locator }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-[var(--black)]">{{ 'payment.reservationDate' | translate }}</span>
            <span class="font-semibold text-[var(--black)] text-right">{{ reservation?.createdAt | date: 'dd/MM/yyyy' }}</span>
          </div>
          <div class="border-t border-[var(--black)] my-4"></div>
          <div class="flex justify-between items-center">
            <span class="text-[var(--black)]">{{ 'payment.detail' | translate }}</span>
            <span class="font-semibold text-[var(--black)] text-right">{{ reservation?.items?.length }} {{ 'payment.items' | translate }}</span>
          </div>
          <div class="border-t border-[var(--black)] my-4"></div>
          <div *ngFor="let item of reservation?.items" class="mb-2">
            <div class="flex justify-between items-center">
              <span class="text-[var(--black)] text-sm">
                {{ item.typeId === 1 ? item.event?.title : ('payment.customRoute' | translate) }}
                <span *ngIf="item.visitorName">({{ item.visitorName }})</span>
              </span>
              <span class="font-semibold text-[var(--black)] text-right text-sm">{{ item.subtotal | currency }}</span>
            </div>
          </div>
          <div class="border-t border-[var(--black)] my-4"></div>
          <div class="flex justify-between items-center">
            <span class="text-[var(--black)]">{{ 'payment.subtotal' | translate }}</span>
            <span class="font-semibold text-[var(--black)] text-right">{{ reservation?.subtotal | currency }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-[var(--black)]">{{ 'payment.discount' | translate }}</span>
            <span class="font-semibold text-[var(--secondary)] text-right">-{{ reservation?.discountAmount | currency }}</span>
          </div>
          <div class="flex justify-between items-center">
            <span class="text-[var(--black)]">{{ 'payment.itbms' | translate }}</span>
            <span class="font-semibold text-[var(--secondary)] text-right">{{ reservation?.itbms | currency }}</span>
          </div>
          <div class="flex justify-between items-center text-lg font-bold">
            <span>{{ 'payment.total' | translate }}</span>
            <span class="text-[var(--secondary)] text-right">{{ reservation?.total | currency }}</span>
          </div>

          <!-- Código de descuento -->
          <div class="flex items-center mt-4 space-x-2">
            <div class="relative flex-1">
              <input type="text" [(ngModel)]="discountCode" [placeholder]="'payment.discountCode' | translate"
                class="appearance-none block w-full px-5 py-3 pr-10 border border-[var(--black)] rounded-2xl placeholder-[var(--dark-grey)] focus:outline-none focus:ring-secondary focus:border-secondary font-bold text-[14px]/[14px]"/>
              <button *ngIf="discountCode"
                (click)="discountCode = ''; affiliateName = ''; applyDiscountCode()"
                class="absolute text-[24px] font-bold right-3 top-1/2 -translate-y-1/2 text-[var(--dark-grey)] hover:text-[var(--black)] cursor-pointer">
                ×
              </button>
            </div>
            <button (click)="applyDiscountCode()" [disabled]="isLoadingCoupon" class="btn-discountCode">
              <span [class.opacity-0]="isLoadingCoupon">{{ 'payment.apply' | translate }}</span>
              <div *ngIf="isLoadingCoupon" class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <div class="w-5 h-5 border-2 border-red border-t-transparent rounded-full animate-spin"></div>
              </div>
            </button>
          </div>

          <!-- Affiliate support message -->
          <div *ngIf="affiliateName" class="mt-2 flex items-center gap-2 text-sm text-[var(--tertiary)]">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
            </svg>
            <span>Con este código estás apoyando a <strong>{{ affiliateName }}</strong></span>
          </div>
        </div>

        <!-- Método de pago -->
        <div class="col-span-1 space-y-6">
          <h3 class="text-xl font-semibold text-[var(--black)]">{{ 'payment.paymentMethod' | translate }}</h3>

          <!-- Selector de método -->
          <div class="flex flex-col gap-3">

            <!-- Apple Pay (solo si disponible) -->
            <label *ngIf="applePayAvailable"
              (click)="selectedPaymentMethod = 'apple-pay'"
              class="flex items-center gap-4 p-4 border-2 rounded-2xl cursor-pointer transition-all"
              [class.border-[var(--black)]]="selectedPaymentMethod === 'apple-pay'"
              [class.border-gray-200]="selectedPaymentMethod !== 'apple-pay'">
              <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0"
                [class.border-[var(--black)]]="selectedPaymentMethod === 'apple-pay'"
                [class.border-gray-300]="selectedPaymentMethod !== 'apple-pay'">
                <div *ngIf="selectedPaymentMethod === 'apple-pay'" class="w-2.5 h-2.5 rounded-full bg-[var(--black)]"></div>
              </div>
              <div class="flex items-center gap-2">
                <svg viewBox="0 0 24 24" class="w-6 h-6" fill="currentColor">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                <span class="font-medium text-[var(--black)]">{{ 'payment.applePay' | translate }}</span>
              </div>
            </label>

            <!-- Tarjeta de crédito/débito -->
            <label
              (click)="selectedPaymentMethod = 'card'"
              class="flex items-center gap-4 p-4 border-2 rounded-2xl cursor-pointer transition-all"
              [class.border-[var(--black)]]="selectedPaymentMethod === 'card'"
              [class.border-gray-200]="selectedPaymentMethod !== 'card'">
              <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0"
                [class.border-[var(--black)]]="selectedPaymentMethod === 'card'"
                [class.border-gray-300]="selectedPaymentMethod !== 'card'">
                <div *ngIf="selectedPaymentMethod === 'card'" class="w-2.5 h-2.5 rounded-full bg-[var(--black)]"></div>
              </div>
              <div class="flex items-center gap-2">
                <svg viewBox="0 0 24 24" class="w-6 h-6" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect>
                  <line x1="1" y1="10" x2="23" y2="10"></line>
                </svg>
                <span class="font-medium text-[var(--black)]">{{ 'payment.card' | translate }}</span>
              </div>
            </label>
          </div>

          <!-- Panel: Apple Pay -->
          <div *ngIf="selectedPaymentMethod === 'apple-pay' && applePayAvailable" class="space-y-4">
            <p class="text-sm text-gray-500">{{ 'payment.applePayDesc' | translate }}</p>
            <apple-pay-button
              buttonstyle="black"
              type="buy"
              locale="es-PA"
              (click)="onApplePayClick()"
              style="--apple-pay-button-width: 100%; --apple-pay-button-height: 52px; --apple-pay-button-border-radius: 12px; display: block;">
            </apple-pay-button>
          </div>

          <!-- Panel: Tarjeta -->
          <form *ngIf="selectedPaymentMethod === 'card'" [formGroup]="paymentForm" (submit)="onPayNow()" class="space-y-4">
            <div class="grid grid-cols-6 gap-4">
              <div class="col-span-6">
                <app-input [control]="paymentForm.controls['cardNumber']" inputId="cardNumber" type="number"
                  [label]="'payment.cardNumber' | translate" placeholder="0000 0000 0000 0000" autocomplete="cc-number" [showErrors]="false">
                </app-input>
              </div>
              <div class="col-span-3">
                <app-input [control]="paymentForm.controls['cardFirstName']" inputId="cardFirstName" type="text"
                  [label]="'payment.firstName' | translate" placeholder="John" autocomplete="cc-given-name"
                  [maxlength]="20" filterType="letters" [showErrors]="false">
                </app-input>
              </div>
              <div class="col-span-3">
                <app-input [control]="paymentForm.controls['cardLastName']" inputId="cardLastName" type="text"
                  [label]="'payment.lastName' | translate" placeholder="Doe" autocomplete="cc-family-name"
                  [maxlength]="20" filterType="letters" [showErrors]="false">
                </app-input>
              </div>
              <div class="col-span-2">
                <app-input [control]="paymentForm.controls['expMonth']" inputId="expmonth" type="text"
                  [label]="'payment.expMonth' | translate" placeholder="08" autocomplete="cc-exp-month"
                  [maxlength]="2" filterType="numbers" [showErrors]="false">
                </app-input>
              </div>
              <div class="col-span-2">
                <app-input [control]="paymentForm.controls['expYear']" inputId="expyear" type="text"
                  [label]="'payment.expYear' | translate" placeholder="27" autocomplete="cc-exp-year"
                  [maxlength]="4" filterType="numbers" [showErrors]="false">
                </app-input>
              </div>
              <div class="col-span-2 flex items-end">
                <app-input [control]="paymentForm.controls['cvv']" inputId="cvv" type="text"
                  [label]="'payment.cvv' | translate" placeholder="123" autocomplete="cc-csc"
                  [maxlength]="4" filterType="numbers" [showErrors]="false">
                </app-input>
              </div>
            </div>

            <p *ngIf="formErrors.length > 0" class="text-red-500 font-bold text-[13px]/[18px]">{{ formErrors[0] }}</p>

            <div class="mt-6">
              <app-button [submit]="true" [text]="'payment.pay' | translate" [styleType]="'primary-flat'" [isLoading]="isLoading" [fullWidth]="true"></app-button>
            </div>

            <p class="font-bold mt-0 text-[10px] text-[var(--dark-grey)] text-center">{{ 'payment.noCardStorage' | translate }}</p>

            <div class="flex flex-wrap justify-center items-center gap-6 py-4">
              <img src="assets/3dsecure-logos/visa.webp" alt="Visa" class="h-auto max-h-12 w-auto max-w-[100px]" />
              <img src="assets/3dsecure-logos/mastercard.webp" alt="Mastercard" class="h-auto max-h-12 w-auto max-w-[100px]" />
              <img src="assets/3dsecure-logos/american-express.webp" alt="American Express" class="h-auto max-h-12 w-auto max-w-[100px]" />
              <img src="assets/3dsecure-logos/poweredbyfac.webp" alt="Powered by FAC" class="h-auto max-h-12 w-auto max-w-[100px]" />
            </div>
          </form>

          <!-- Términos (aplica a todos los métodos) -->
          <div class="space-y-2 pt-2">
            <p class="text-center text-sm text-[var(--black)]">
              {{ 'payment.termsText' | translate }}
              <a href="/policies/terms" target="_blank" class="text-[var(--secondary)] hover:underline">{{ 'payment.termsLink' | translate }}</a>.
            </p>
            <p class="mt-2 text-center text-xs text-[var(--dark-grey)]">
              <span class="font-semibold">{{ 'event.disclaimer' | translate }}</span><br>
              {{ 'event.disclaimerFull' | translate }}
            </p>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Modal 3DS -->
<div *ngIf="redirectHtml" class="fixed inset-0 z-[9999999] flex items-center justify-center">
  <div class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"></div>
  <div class="relative z-10 w-full max-w-md mx-4 max-h-[90vh] bg-white rounded-2xl shadow-2xl overflow-hidden">
    <div class="flex items-center justify-between p-4 border-b border-gray-200 bg-gray-50">
      <h3 class="text-lg font-semibold text-gray-900">{{ 'payment.verificationTitle' | translate }}</h3>
      <button (click)="closeModal()" class="p-1 rounded-full hover:bg-gray-200 transition-colors">
        <svg class="w-6 h-6 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
        </svg>
      </button>
    </div>
    <div class="relative">
      <div *ngIf="isIframeLoading" class="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-20">
        <div class="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
      <div class="w-full h-[600px] max-h-[70vh]">
        <iframe [srcdoc]="redirectHtml" (load)="iframeLoaded()" class="w-full h-full border-0" [class.hidden]="isIframeLoading" frameborder="0"></iframe>
      </div>
    </div>
    <div class="px-4 py-3 bg-gray-50 border-t border-gray-200 text-center">
      <p class="text-xs text-gray-500">{{ 'payment.verificationDesc' | translate }} <span *ngIf="timer">{{ timer }}</span></p>
      <p class="text-xs text-gray-400">{{ 'payment.dontClose' | translate }}</p>
    </div>
  </div>
</div>
